//Placeholder to prevent files using old store style from erroring out
export default {};
